<div class="tender-filter-container d-flex align-items-center" [ngClass]="{ 'loading-filters': !userDataLoaded }">
  <!--case text search enabled, ie. in tender search view-->
  @if (inTenderSearchView) {
    <div class="d-flex gap-2">
      <!--selector between 2 search modes : topics or text-->
      <app-filter-text-and-items
        class="filter-text-and-topics"
        [itemsSectionName]="'thèmes'"
        [items]="selectableItems"
        [placeholder]="'tenders.search-a-tender' | translate"
        (textSelect)="textSelected($event)"
        (itemSelect)="topicSelected($event)"
        (clearChange)="clearTextAndTopic()"
        openAfterInit
      >
        <ng-template #leftIconTemplate>
          <mat-icon class="filter-icon" svgIcon="text-or-topic-filter" />
        </ng-template>
      </app-filter-text-and-items>
      <!--input text for filter.organisation-->
      <ex-filter-text
        [placeholder]="'tenders.filter-organisation' | translate"
        [text]="tenderSearchService.organisation"
        [variant]="'light'"
        (textEnter)="organisationSearch($event)"
      >
        <ng-template #leftIconTemplate>
          <mat-icon class="filter-icon" svgIcon="organisation-filter" />
        </ng-template>
      </ex-filter-text>
    </div>
  } @else {
    <!--case only topics, ie. in market watch views-->
    <app-filter-topic
      *ngIf="!filters || filters.includes(FilterType.TOPIC)"
      [items]="tenderTopics || []"
      [defaultTopicIds]="defaultTopicIds"
      (itemsSelected)="topicsSelected($event)"
    />
  }

  <!--other filters are common-->
  <app-filter-date
    [displayedEstimatedEndPeriod]="inTenderSearchView"
    [ngClass]="{ lg: inTenderSearchView, 'is-firefox': browser.isFirefox }"
    [tenderSearchService]="tenderSearchService"
    *ngIf="!filters || filters.includes(FilterType.PERIOD)"
    (periodSelected)="periodSelected($event)"
    [defaultPeriod]="defaultPeriod ? defaultPeriod : undefined"
  />
  <app-filter-territory
    *ngIf="!filters || filters.includes(FilterType.TERRITORY)"
    [items]="territoryItems"
    [defaultTerritories]="defaultTerritoriesIds"
    [alternativeDisplay]="alternativeDisplay"
    [selectionCount]="territorySelectionCount"
    [maxCount]="totalCount"
    (territoriesSelected)="territoriesSelected($event)"
  />
  <app-filter-tender-type
    *ngIf="!filters || filters.includes(FilterType.TENDER_TYPE)"
    [defaultTypes]="defaultTenderTypes"
    (typesSelected)="tenderTypesSelected($event)"
  />
  <app-filter-market-type
    *ngIf="!filters || filters.includes(FilterType.TENDER_TYPE)"
    [defaultTypes]="defaultMarketTypes"
    (typesSelected)="marketTypesSelected($event)"
  />
</div>
